<div [hidden]="buttonLoading">
    @if (buttonIcon) {
        <fa-icon [icon]="buttonIcon" [fixedWidth]="true" />
    }
    &nbsp;
    <span [ngClass]="{ 'd-none': hideLabelMobile, 'd-md-inline': hideLabelMobile }">{{ buttonLabel }}</span>
</div>
<fa-icon [hidden]="!buttonLoading" animation="spin" [icon]="faCircleNotch" />
